import { Eye, LogOut } from 'lucide-react'

import { personLabelWithEmail } from '@/lib/person-label'
import { useAuth } from '@/lib/auth'
import { useStopImpersonation } from '@/modules/iam'

export function ImpersonationBanner() {
  const { user } = useAuth()
  const stop = useStopImpersonation()
  const impersonation = user?.impersonation
  if (!user || !impersonation) return null

  return (
    <div
      role="region"
      aria-label="Impersonation status"
      className="fixed inset-x-0 top-0 z-50 flex h-8 items-center gap-2 border-b border-warning/40 bg-warning/15 px-4 text-xs text-warning-foreground"
    >
      <span role="status" className="flex items-center gap-2">
        <Eye className="size-3.5 shrink-0" aria-hidden="true" />
        <span>
          Viewing as <strong className="font-semibold">{personLabelWithEmail(user)}</strong>
          {', signed in as '}
          {impersonation.actorName}.
        </span>
      </span>
      <button
        type="button"
        onClick={() => stop.mutate()}
        disabled={stop.isPending}
        className="ml-auto flex items-center gap-1 rounded-md border border-warning/50 px-2 py-0.5 font-medium transition-colors hover:bg-warning/20 disabled:opacity-50"
      >
        <LogOut className="size-3" aria-hidden="true" />
        {stop.isPending ? 'Exiting…' : 'Exit impersonation'}
      </button>
    </div>
  )
}
